export const MATERIAL_QUANTITY_SUMMARY_EXPORT_URL = "/materials/quantity-summary-raw/";

export const buildMaterialReportParams = (
    dateRange: [string | null, string | null],
    params: Record<string, string>,
) => ({
    ...params,
    start_date: dateRange[0],
    end_date: dateRange[1],
});
